import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { urlWMSInundaciones, formatoPNG } from './configuracion';

const  layer00220 = new TileLayer({
  title: 'Máscara 20071020',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20071020l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00220.setVisible(false);

const layer00219 = new TileLayer({
  title: 'Máscara 20071105',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20071105l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00219.setVisible(false);
 
const layer00218 = new TileLayer({
  title: 'Máscara 20080209',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20080209l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00218.setVisible(false);
  
const layer00217 = new TileLayer({
  title: 'Máscara 20080413',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20080413l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00217.setVisible(false);
  
const layer00216 = new TileLayer({
  title: 'Máscara 20080608',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20080608l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00216.setVisible(false);
  
const layer00215 = new TileLayer({
  title: 'Máscara 20080624',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20080624l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00215.setVisible(false);
  
const layer00214 = new TileLayer({
  title: 'Máscara 20080710',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20080710l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00214.setVisible(false);
  
const layer00213 = new TileLayer({
  title: 'Máscara 20080718',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20080718l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00213.setVisible(false);

const layer00212 = new TileLayer({
  title: 'Máscara 20080726',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20080726l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00212.setVisible(false);

const layer00211 = new TileLayer({
  title: 'Máscara 20080803',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20080803l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00211.setVisible(false);

const layer00210 = new TileLayer({
  title: 'Máscara 20080811',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20080811l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00210.setVisible(false);

const layer00209 = new TileLayer({
  title: 'Máscara 20080819',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20080819l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00209.setVisible(false);

const layer00208 = new TileLayer({
  title: 'Máscara 20080827',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20080827l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00208.setVisible(false);

export const grupoCapa01_14 = new LayerGroup({
  title: 'Ciclo Hidrológico 2007-2008',
  fold: 'close',
  layers: [layer00208, layer00209, layer00210, layer00211, layer00212, layer00213, layer00214, layer00215, layer00216, layer00217, layer00218, layer00219, layer00220]
});